module.exports = __webpack_public_path__ + "static/media/02.20124e15.mp3";